export const HEATMAP_VALUE_CELL_TOOL_TIP_LABEL = 'View Projects';